<template>
  <div class="customer-detail">
    <div
      class="popup-overlay"
      v-esc="() => $emit('close')"
      :class="{ show: isPopupVisible }"
      v-if="isPopupVisible"
    >
      <div class="popup-right" v-click-outside="vcoConfig">
        <div class="popup-right__content">
          <div class="popup-right__header">
            <h4>{{ title }}</h4>
            <div
              id="popup-right__close"
              class="popup-right__close"
              @click="$emit('close')"
            >
              <base-icon name="close-circle" />
            </div>
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseIcon } from "@/components";

export default {
  name: "PopupRight",
  components: {
    BaseIcon,
  },
  props: {
    title: String,
    isPopupVisible: Boolean,
  },
  data() {
    return {
      vcoConfig: {
        handler: this.handler,
        middleware: this.middleware,
        events: ["click"],
      },
    };
  },
  methods: {
    middleware(event) {
      return event.target.className?.baseVal !== "popup-right";
    },
    handler() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-overlay.show {
  position: fixed;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
  opacity: 1;
  transition: all ease-in 0.4s;
}
.show .popup-right {
  right: 0;
  @media (max-width: 640px) {
    overflow: auto;
  }
}
.popup-right {
  position: fixed;
  top: 0;
  right: -100%;
  z-index: 10;
  background-color: var(--grayscale-150);
  padding: 0px 20px;
  height: 100vh;
  transition: all ease-in 0.4s;

  @media (min-width: 768px) {
    width: 90%;
  }
  @media (min-width: 1024px) {
    width: 93%;
  }
  @media (min-width: 1025px) {
    width: 960px;
  }
  @media (max-width: 800px) {
    width: 100%;
    padding: 10px 16px;
    box-sizing: border-box;
  }
  &__content {
    position: relative;
    height: 100%;
    @media (max-width: 583px) {
      overflow-y: auto;
    }
    @media (max-width: 640px) {
      height: auto;
    }
  }
  &__close {
    cursor: pointer;

    @media (max-width: 768px) {
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
  &__header {
    border-bottom: 1px solid var(--grayscale-20);
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 82px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
      min-height: 55px;
      margin-bottom: 16px;
    }

    h4 {
      font-weight: 600;

      @media (max-width: 768px) {
        font-size: 16px;
      }
    }
  }
  ::v-deep .infoArea {
    position: relative;
    font-size: 13px;
    padding: 12px 3px;
  }
}
</style>
